<style>
.date-range > input {
  width: 80px !important;
}

.btn:hover {
  color: #ffffff !important;
}

/* custom-search */
.custom-search .v-text-field__slot input {
  border-bottom: none !important;
  padding: 5px 12px !important;
  margin: 0 !important;
}

.custom-search .v-label {
  padding: 0 12px;
  top: 12px;
}

.custom-search .v-text-field__slot input:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}
</style>
<template lang="pug">
.main-content-padded
  .vspace.large
  .row
    .col.s12
      .bcrumb
        a Users
  .row
    .col.s12
      v-card
        v-card-title
          v-layout.justify-space-between.align-center.wrap
            v-flex.sm7
            v-flex.sm5
              v-spacer
              v-text-field.custom-search(
                v-model='search',
                append-icon='search',
                label='Search',
                single-line='',
                hide-details=''
              )
        v-card-text
          v-data-table(
            :headers='headers',
            :items='accounts',
            :search='search',
            :pagination.sync='pagination',
            v-if='accounts.length'
          )
            template(slot='items', slot-scope='props')
              tr
                td
                  a(href='#', @click='showAccount(props.item)') {{ props.item.email }}
                td {{ props.item.firstName }}
                td {{ props.item.lastName }}
                td {{ props.item.status }}
                td
                  v-switch(
                    :input-value='isActive(props.item.status)',
                    @change='confirmAccountToggle(props.item)'
                  )
            v-alert(
              slot='no-results',
              :value='true',
              color='red',
              icon='warning'
            )
              | Your search for &quot;{{ search }}&quot; found no results.

          p.subtitle.medium(v-else) There is no personel available.
</template>
<script>
import axios from 'axios'
import AppAccountDetails from '@/components/app-acount-detail'

export default {
  meta: {
    title: 'Users'
  },
  data () {
    return {
      deleteAccountModal: null,
      account: null,
      accountIndex: null,
      accounts: [],
      // isActive: true,
      headers: [
        { text: 'Email', value: 'email', align: 'left' },
        { text: 'First Name', value: 'firstName', align: 'left' },
        { text: 'Last Name', value: 'lastName', align: 'left' },
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'Action', value: '', align: 'left' }
      ],
      search: '',
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  mounted () {
    this.getAccounts()
  },
  watch: {
    supplier () {
      this.getAccounts()
    }
  },
  computed: {
    hasAccounts () {
      return this.accounts && this.accounts.length
    },

    user () {
      return this.$store.state.auth.user || {}
    },

    supplier () {
      return this.$store.state.profile.supplier || {}
    },
    isActive () {
      return (status) => (status === 'active')
    },
    newStatus () {
      return (status) => (status === 'active' ? 'inactive' : 'active')
    },
    status: {
      get () {
        return this.isActive
      },
      set (status) {
        this.isActive = !!(status && status === 'active')
      }
    }
  },
  methods: {
    getAccounts () {
      return this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return axios
          .get(
            `${this.$config.API_URL}/suppliers/${this.supplier.code}/accounts/${this.user.id}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then((result) => {
            this.accounts = result.data
          })
      })
    },
    showAccount (account, index) {
      this.account = account
      this.accountIndex = index
      const modalParams = {
        content: AppAccountDetails,
        bind: {
          account: account,
          onSave: this.saveAccount,
          onCancel: this.closeModal
        },
        style: {
          padding: 'medium'
        }
      }
      this.$store.dispatch('modal/open', modalParams)
    },
    addAccount () {
      const modalParams = {
        content: AppAccountDetails,
        bind: {
          account: {
            email: null,
            firstName: null,
            lastName: null,
            localMembership: { username: null },
            subSupplierId: this.user.id
          },
          isNewAccount: true,
          onSave: this.saveAccount,
          onCancel: this.closeModal
        },
        style: {
          padding: 'medium'
        }
      }

      this.$store.dispatch('modal/open', modalParams)
    },
    closeModal () {
      this.account = null
      this.accountIndex = null
      this.$store.dispatch('modal/close')
    },
    saveAccount (account, isNew) {
      this.$store
        .dispatch('auth/getAccessToken')
        .then((accessToken) => {
          if (isNew) {
            return axios
              .post(
                `${this.$config.API_URL}/suppliers/${this.supplier.code}/accounts`,
                // `${this.$config.API_URL}/suppliers/prestige/accounts`,
                account,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`
                  }
                }
              )
              .then((result) => {
                this.accounts.push(result.data)
                this.getAccounts()
                this.$snackbar.show({
                  text: 'Account created successfully'
                })
              })
          } else {
            return axios
              .put(
                `${this.$config.API_URL}/suppliers/prestige/accounts/${account.uid}`,
                account,
                {
                  headers: {
                    Authorization: `Bearer ${accessToken}`
                  }
                }
              )
              .then((result) => {
                this.getAccounts()
                this.accounts.splice(this.accountIndex, 1, result.data)
                this.$snackbar.show({
                  text: 'Account updated successfully'
                })
              })
          }
        })
        .then(() => {
          this.$store.dispatch('modal/close')
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            this.$snackbar.error(
              'Unable to add account: '
                + err.response.data.errors[0].messages[0]
            )
          } else {
            this.$snackbar.error('Unable to add account: ' + err.message)
          }
        })
    },
    confirmAccountToggle (index) {
      this.account = this.accounts[index]
      this.accountIndex = index
      let newStatus = this.newStatus(this.account.status)
      this.toggleStatus(this.account, newStatus)

      // const modalParams = {
      //   content: AppAccountDetails,
      //   bind: {
      //     account: this.account,
      //     accountIndex: this.accountIndex,
      //     onRemove: this.toggleStatus,
      //     onCancel: this.closeModal,
      //     forRemoval: true,
      //   },
      //   style: {
      //     padding: 'medium',
      //   },
      // }

      // this.$store.dispatch('modal/open', modalParams)
    },
    toggleStatus (account, newStatus) {
      account.status = newStatus // this.newStatus(account.status)
      this.$store
        .dispatch('auth/getAccessToken')
        .then((accessToken) => {
          return axios
            .put(
              `${this.$config.API_URL}/suppliers/${account.supplierId}/accounts/${account.uid}`,
              account,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
              }
            )
            .then(() => {
              this.getAccounts()
              this.accounts[this.accountIndex].status = account.status
              this.$snackbar.show({
                text:
                  account.status === 'active'
                    ? 'Account activated successfully'
                    : 'Account deactivated successfully'
              })
            })
        })
        .then(() => {
          this.$store.dispatch('modal/close')
        })
    }
  },
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/page-users.vue